module.exports = __webpack_public_path__ + "static/media/contact.73bfe0fc.jpeg";